import AvisoEvaluacion from '../domain/AvisoEvaluacion';

export default async function notifyProcesoEvaluacion(repository, expediente, programacion, motivoSolicitud, numeroOficio) {
  const avisoEvaluacion = new AvisoEvaluacion(
    {
      nombre: `${expediente.Personal.nombre} ${expediente.Personal.segundoNombre} ${expediente.Personal.apaterno} ${expediente.Personal.amaterno}`,
      fecha_poligrafo: programacion.fechaEvaluacionPoligrafica,
      fecha_medico: programacion.fechaEvaluacionMedica,
      fecha_piscologia: programacion.fechaEvaluacionPsicologica,
      fecha_ise: programacion.fechaEntrevistaIse,
      motivo_solicitud: motivoSolicitud,
      numero_oficio: numeroOficio,
      fecha_integracion: programacion.fechaEvaluacionIntegracion,
    },
    expediente.Personal.vigenciaAnio,
  );
  await repository.notifyProcesoEvaluacion(avisoEvaluacion);
}
